module.exports = __webpack_public_path__ + "static/media/waterWaves.07d22169.svg";